/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-21 18:30:40
 */

import DayReport from "../dayReport";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import DayReportApi,{DayReportDOI} from "../api/dayReportApi";
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import DatePicker from 'src/types/iview/DatePicker';
import dayjs from 'dayjs';
import { WEEK } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import FileUtil from 'src/util/fileUtil';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';

export default class DayReportService extends ListPageService {
	ctx: DayReport;

	constructor (ctx: DayReport) {
	    super()
		this.ctx = ctx
	}

    op:DayReportDOI.DatePickerOptions = {
        shortcuts: [
            {
                text: '1季度',
                show: true,
                value () {
                    var currentDate = new Date();
                    //获得当前年份4位年
                    var currentYear = currentDate.getFullYear();
                    const start = new Date(currentYear, 0, 1);
                    var end = new Date(currentYear, 2, 31);
                    return [start,end];
                },
                onClick(picker) {
                }
            },
            {
                text: '2季度',
                show: true,
                value(){
                    var currentDate = new Date();
                    //获得当前年份4位年
                    var currentYear = currentDate.getFullYear();
                    //第二季度第一天
                    const start = new Date(currentYear, 3, 1);
                    var end = new Date(currentYear, 5, 30);
                    return [start, end];
                },
                onClick(picker) {
                }
            },
            {
                text: '3季度',
                show: true,
                value(){
                    var currentDate = new Date();
                    //获得当前年份4位年
                    var currentYear = currentDate.getFullYear();
                    const start = new Date(currentYear, 6, 1);
                    var end = new Date(currentYear, 8, 30);
                    return [start, end];
                },
                onClick(picker) {
                }
            },
            {
                text: '4季度',
                show: true,
                value(){
                    var currentDate = new Date();
                    //获得当前年份4位年
                    var currentYear = currentDate.getFullYear();
                    const start = new Date(currentYear, 9, 1);
                    var end = new Date(currentYear, 11, 31);
                    return [start, end]
                },
                onClick(picker) {
                }
            }
        ]
    }

    @override
	createColumns (): ColDefCustom [] {
        let t = this
        if(this.ctx.currentDataType === '周报') {
            return [
                {
                    headerName: '时间',
                    field: 'DataTime',
                    minWidth: 180,
                    // cellClass: function(params) {
                    //     return params.data.data_type !== 1?'text-center': ''
                    // },
                    colSpan: function(params) {
                        return params.data.data_type === 1?1:2
                    }
                },
                {
                    headerName: '星期',
                    field: 'DataTime',
                    minWidth: 180,
                    cellRenderer(params) {
                        return WEEK[dayjs(params.data.DataTime).day()]
                    }
                },
            ]

        } else {
            return [
                {
                    headerName: '时间',
                    field: 'DataTime',
                    minWidth: 180,
                },
            ]
        }
		
	}

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        if (this.ctx.currentDataType === '日报') {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'date', format: 'yyyy-MM-dd', placeholder: '请选择时间', clearable: false },
                },
            ];
        } else if (this.ctx.currentDataType === '周报') {
            return [
                {
                    component: 'el-date-picker',
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'week', format: 'yyyy 第 WW 周', placeholder: '请选择时间', clearable: false },
                },
            ];
        }else if (this.ctx.currentDataType === '月报') {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'month', format: 'yyyy-MM', placeholder: '请选择时间', clearable: false },
                },
            ];
        } else if (this.ctx.currentDataType === '季报'){
            return[
                {
					component: DatePicker,
		 		    label: '时间',
		            field: 'time',
		            width: 300,
		            realField: ['start_time','end_time'],
		            props: {value: DateTimeUtil.getCurrentQuarter(), type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间',
					options:this.op},
				 },
            ]
        }else if (this.ctx.currentDataType === '自定义报表'){
            return[
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 300,
                    realField: ['start_time', 'end_time'],
                    timeType: 'number',
                    props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
                },
            ]
        }else {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'year', format: 'yyyy', placeholder: '请选择时间', clearable: false },
                },
            ];
        }
    }
    
    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '导出',
                type: 'info',
                async onClick() {
                    let params:any = t.ctx.queryForm.getQueryObj<DayReportDOI.QueryRowDataParamsI>()
                    let startTime, DataType
                    switch (t.ctx.currentDataType) {
                        case '日报':
                            startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'start')
                            DataType = 1
                            break;
                        case '周报':
                            startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'weekStart')
                            DataType = 2
                            break;
                        case '月报':
                            startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'monthStart')
                            DataType = 3
                            break;
                        case '季报':
                            startTime = DateTimeUtil.getSecondFromIviewDate(params.start_time, 'monthStart')
                            // DataType = 4
                            DataType = 5
                            break;
                        case '自定义报表':
                            startTime = params.start_time
                            // DataType = 3
                            DataType = 6
                            break;
                        case '年报':
                            startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'yearStart')
                            DataType = 4
                            break;
                    }
                    var paramss = {
                        header: t.ctx.columnDefs,
                        body: t.ctx.rowData,
                        data_type: DataType,
                        mn: t.ctx.mn,
                        timestamp: startTime
                    }
                    let { code, data } = await DayReportApi.exportChange(paramss)
                    if (code === 0) {
                        FileUtil.download(data.download_url);
                    }
                },
            },
        ];
    }

	@override
	initSearchParams (): void {
        if(!this.ctx.mn) {
            return
        }
        let params:any = this.ctx.queryForm.getQueryObj<DayReportDOI.QueryRowDataParamsI>()
        let endTime, startTime
        switch (this.ctx.currentDataType) {
            case '日报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'start')
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'end')
                break;
            case '周报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'weekStart')
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'weekEnd')
                break;
            case '月报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'monthStart')
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'monthEnd')
                break;
            case '季报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.start_time, 'monthStart')
                endTime = DateTimeUtil.getSecondFromIviewDate(params.end_time, 'monthEnd')
                break;
            case '自定义报表':
                startTime = params.start_time
                endTime = params.end_time
                break;
            case '年报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'yearStart')
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'yearEnd')
                break;
        }
		this.ctx.searchParams = {
            mn: this.ctx.mn,
            start_time: startTime,
            end_time:endTime,
        }
		this.ctx.currentPage = 1
    }
    transData(data: any[], key) {
        let map = {}
        data.forEach(i=> {
            map[i.data_type] = map[i.data_type]||[]
            map[i.data_type].push(i)
        })
        let arr = []
        Array.prototype.push.apply(arr, map[1].map(i=> ({
            DataTime: i.DataTime,
            data_type: i.data_type,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[7].map(i=> ({
            DataTime: '样本数',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        if(this.ctx.currentDataType === '日报'){
            // Array.prototype.push.apply(arr, map[16].map(i=> ({
            //     DataTime: '有效样本数',
            //     data_type: i.data_type,
            //     footer: true,
            //     ...i.datas
            // })))
        }
        Array.prototype.push.apply(arr, map[3].map(i=> ({
            DataTime: '最大值',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[2].map(i=> ({
            DataTime: '最小值',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[4].map(i=> ({
            DataTime: '平均值',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[5].map(i=> ({
            DataTime: '水质级别',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[6].map(i=> ({
            DataTime: '总体水质类别',
            data_type: i.data_type,
            footer: true,
            [key]: i.datas,
        })))
        Array.prototype.push.apply(arr, map[8].map(i=> ({
            DataTime: '目标水质类别',
            data_type: i.data_type,
            footer: true,
            [key]: i.datas,
        })))
        Array.prototype.push.apply(arr, map[9].map(i=> ({
            DataTime: map[8][0].datas+'类水质标准',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        // Array.prototype.push.apply(arr, map[10].map(i=> ({
        //     DataTime: '单项数据捕获率(%)',
        //     data_type: i.data_type,
        //     footer: true,
        //     ...i.datas
        // })))
        // Array.prototype.push.apply(arr, map[11].map(i=> ({
        //     DataTime: '平均数据捕获率(%)',
        //     data_type: i.data_type,
        //     footer: true,
        //     [key]: i.datas,
        // })))
        Array.prototype.push.apply(arr, map[12].map(i=> ({
            DataTime: '单项数据有效率(%)',
            data_type: i.data_type,
            footer: true,
            ...i.datas
        })))
        Array.prototype.push.apply(arr, map[13].map(i=> ({
            DataTime: '平均数据有效率(%)',
            data_type: i.data_type,
            footer: true,
            [key]: i.datas,
        })))
        // Array.prototype.push.apply(arr, map[14].map(i=> ({
        //     DataTime: '单项数据故障率(%)',
        //     data_type: i.data_type,
        //     footer: true,
        //     ...i.datas
        // })))
        // Array.prototype.push.apply(arr, map[15].map(i=> ({
        //     DataTime: '平均数据故障率(%)',
        //     data_type: i.data_type,
        //     footer: true,
        //     [key]: i.datas,
        // })))
        console.log('arr', arr)
        return arr
    }
    @override
    async searchTable() {
        let ctx = this.ctx;
        if(!ctx.mn) {
            return;
        }
        if(ctx.searchParams["start_time"] == null || ctx.searchParams["end_time"] == null){
            return;
        }
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let api
        if(this.ctx.currentDataType === '日报') {
            api = DayReportApi.searchDayList
        } else if(this.ctx.currentDataType === '年报' || this.ctx.currentDataType === '季报') {
            api = DayReportApi.searchYearList
        } else {
            api = DayReportApi.searchWeekMonthList
        }
        let { code, data } = await api({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.columnDefs = []
            ctx.rowData = []
            ctx.columnDefs = [
                ...this.createColumns(),
                ...data.header.map((i,index) => ({
                    headerName: `${i.name}(${i.unit})`,
                    field: i.key,
                    minWidth: 100, 
                    // cellClass: function(params) {
                    //     return [6, 8].includes(params.data.data_type)?'text-center': ''
                    // },
                    colSpan: function(params) {
                        if(index === 0) {
                            return [6, 8].includes(params.data.data_type) ? data.header.length : 1
                        } else {
                            return 1
                        }
                    },
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender(h, params) {
                            let data = params.data;
                            if(data[i.key +'-NullData']){
                                return (
                                    <span style="color:#FFFB00" //黄色
                                    >
                                    {data[i.key]}
                                    </span>
                                );
                            }else{
                                return (
                                    <span style="color:#FFFFFF"//白色
                                    >
                                    {data[i.key]}
                                    </span>
                                );
                            }
                        },
                    },
                })),
            ];
            ctx.rowData = data.data_info.length>0?this.transData(data.data_info, data.header[0].key):[];
            ctx.total = data.page_count;
        }
    }

}